import type AttachmentPreviewWellView from './schema/AttachmentPreviewWellView';
import type BusStopState from './schema/BusStopState';
import type ConversationItem from './schema/ConversationItem';
import type ListViewStore from './schema/ListViewStore';
import type TableView from './schema/TableView';
import type TableViewConversationRelation from './schema/TableViewConversationRelation';
import type RowInfoForVLV from './schema/RowInfoForVLV';
import type TableViewItemRelation from './schema/TableViewItemRelation';
import { ObservableMap } from 'mobx';
import type { AttachmentFullViewState } from 'owa-attachment-well-data';
import { createStore } from 'satcheljs';
import type { ClientItem } from 'owa-mail-store';
export { ObservableMap };
import type ActionButtonData from 'txp-data/lib/schema/viewSchema/ActionButtonData';

const listViewDefaultStore: ListViewStore = {
    conversationItems: new ObservableMap<string, ConversationItem>({}),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (21,5): Type 'null' is not assignable to type 'MailListItemContextMenuState'.
    // @ts-expect-error
    itemContextMenuState: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (25,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    selectedTableViewId: null,
    tableViewConversationRelations: new ObservableMap<string, TableViewConversationRelation>({}),
    tableViewItemRelations: new ObservableMap<string, TableViewItemRelation>({}),
    tableViews: new ObservableMap<string, TableView>({}),
    attachmentViewStates: new ObservableMap<string, AttachmentFullViewState>({}),
    expandedConversationViewState: {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (34,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        expandedRowKey: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (38,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        focusedNodeId: null,
        selectedNodeIds: [],
        allNodeIds: [],
        shouldBeExpanded: false,
        busStopStateMap: new ObservableMap<string, BusStopState>({}),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (46,9): Type 'null' is not assignable to type 'ConversationFork[]'.
        // @ts-expect-error
        forks: null,
    },
    rowAttachmentPreviewWellViews: new ObservableMap<string, AttachmentPreviewWellView>({}),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (52,5): Type 'null' is not assignable to type 'DropViewState'.
    // @ts-expect-error
    focusedOtherDropViewState: null,
    rowInfoForVLV: new ObservableMap<string, RowInfoForVLV>({}),
    meetingMessageItems: new ObservableMap<string, ClientItem>({}),
    offsetHeight: 0,
    scrollTop: 0,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (61,5): Type 'null' is not assignable to type 'OwaDate'.
    // @ts-expect-error
    inboxPausedDateTime: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (65,5): Type 'null' is not assignable to type 'number'.
    // @ts-expect-error
    inboxPausedLength: null,
    txpActionButtonData: new ObservableMap<string, ActionButtonData>({}),
    lastIndexToRender: 0,
    doNotVirtualize: false,
};

export let getStore = createStore<ListViewStore>('listview', listViewDefaultStore);
const listViewStore = getStore();

export default listViewStore;
